import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "../../Shared/app.Masters.Service";
import { LmsService } from "../services/lms.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../../snackbar/snackbar.component";

declare var $: any;

@Component({
  selector: "app-dsa-payout-detail",
  templateUrl: "./dsa-payout-detail.component.html",
  styleUrls: ["./dsa-payout-detail.component.scss"],
})
export class DsaPayoutDetailComponent implements OnInit {
@ViewChild(MatPaginator) paginatorRef!: MatPaginator;
@ViewChild('paginatorRef1') paginatorRef1!: MatPaginator;

@ViewChild(MatSort) sort!: MatSort;

  currentUser: any;
  showSpinner = false;
  tab: any = "PeriodicPayout";
  ToDate: any = new Date();
  FromDate: any = new Date();
  selectedAccounting: any = null;
  accountingData: any[] = [];
  periodicPayoutData: any;
  // Loan Payout
  loanCategoryIds: number[] = [];
  AppCaseNo: any;
  CustomerN: any;
  dataSourceCustomer: any;
  dataSourceCustomerLoan: any;
  displayedCustomerColumns: string[] = [];
  displayLoanCustomerColumn: string[] = [];
  CustomerId: any;
  Customer: any = {};
  CustomerList: any[] = [];
  CustomerLoanList: any[] = [];
  employeeDropdown: any = [];
  SelectType: any = "";
  BranchesList: any = [];
  SalesExecutiveData: any = [];
  CollectionExecutiveData: any = [];
  SourceAreaData: any = [];
  areaData: any = [];
  collectionArea: any = [];
  subAreaData: any = [];
  AccCatDropdown: any[] = [];
  BranchId: any;

// loan payout end
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  displayedColumns = [
    "Loan_Id",
    "LoanAcNo",
    "Loan_Date",
    "CustomerName",
    "Customer_PhoneNo",
    "Address",
    "LoanAmount",
    "EMI_Frequency",
    "DueDate",
    "EMI_No",
    "EMI_AMount",
    "payout"
  ];
  constructor(
    private dataSharingService: DataSharingService,
    private _MasterService: MasterService,
    private lmsService: LmsService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("DSA Payout Detail");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.Get_ACC_Category_ForDropdown_By_Type();
  }
  changeTab(tab: any) {
    if (tab !== this.tab) {
      this.tab = tab;
      $(".filterInput").val("");
      if (tab === "PeriodicPayout") {
        this.Get_ACC_Category_ForDropdown_By_Type();
        this.selectedAccounting = null;
        this.FromDate = new Date();
        this.ToDate = new Date();
      } else if (tab === "LoanPayout") {
        this.dataSourceCustomerLoan= null;
      }
    }
  }
  Get_ACC_Category_ForDropdown_By_Type() {
    this.showSpinner = true;
    this.lmsService
      .Get_ACC_Category_ForDropdown_By_Type({ Type: 'DSA' })
      .subscribe((response: any) => {
        if (response.length > 0) {
          this.accountingData = response;
          this.loanCategoryIds = response.map((item: any) => item.Loan_CategoryId); // store only the IDs
        }
        this.showSpinner = false;
      });
  }
  onAccountingSearch() {
    this.showSpinner = true;

    const formattedFromDate = this.FromDate
      ? new Date(this.FromDate).toISOString()
      : null;
    const formattedToDate = this.ToDate
      ? new Date(this.ToDate).toISOString()
      : null;
    const requestDataforTable = {
      Search: {
        FromDate: formattedFromDate,
        ToDate: formattedToDate,
        LoanAccountingCatId: this.selectedAccounting.Loan_CategoryId,
      },
    };
    console.log("Requesting data for table", requestDataforTable);
    this.lmsService
      .LMS_Get_PeriodicPayoutDetail({
        JSON: JSON.stringify(requestDataforTable),
      })
      .subscribe((response: any) => {
        if (response.length > 0) {
          this.periodicPayoutData = new MatTableDataSource(response);
          this.periodicPayoutData.paginator = this.paginatorRef;
          this.periodicPayoutData.sort = this.sort;
          console.log("periodic Payout Data", this.periodicPayoutData);
        }
        this.showSpinner = false;
      });
  }
  exportPeriodicData(exporter: any){
    exporter.exportTable("xls", {
      fileName: "DSA Payout Detail",
      sheet: "DSA Payout Detail",
    });
  }
  // Loan Payout
  exportloanInfoData(exporter: any){
    exporter.exportTable("xls", {
      fileName: "DSA Loan Detail",
      sheet: "DSA Loan Detail",
    });
  }
  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUser.userId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
      });
  }

  GetCollectionExecutive() {
    this.lmsService
      .Get_Collection_Ex_By_UserId({
        
        LoginUserId: this.currentUser.userId,
        BranchId: "",
      })
      .subscribe((res) => {
        this.CollectionExecutiveData = JSON.parse(JSON.stringify(res));
      });
  }

  GetSalesExecutive() {
    this.lmsService
      .Get_Collection_Ex_By_UserId({
        LoginUserId: this.currentUser.userId,
        BranchId: "",
      })
      .subscribe((res) => {
        this.SalesExecutiveData = JSON.parse(JSON.stringify(res));
      });
  }

  getAreaByUserId() {
    this.lmsService
      .Get_Area_By_UserId({
        BranchId: "",
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        this.areaData = JSON.parse(JSON.stringify(res));
      });
  }

  getSubAreaByUserId() {
    this.lmsService
      .Get_SubArea_By_UserId({
        BranchId: "",
        LoginUserId: this.currentUser.userId,
      })
      .subscribe((res: any) => {
        this.subAreaData = JSON.parse(JSON.stringify(res));
      });
  }

  SearchChange() {
    this.getBranchesList();
    this.GetCollectionExecutive();
    this.GetSalesExecutive();
    this.getAreaByUserId();
    this.getSubAreaByUserId();
    this.Get_ACC_Category_ForDropdown_By_Type();
    this.Customer = {
      CloseCase: "",
      BranchId: "",
      Area: "",
      SubArea: "",
      SalesEx: "",
      CollectionEx: "",
      LoanAccountingCatId: "",
    };
  }
  searchCustomer() {
    this.dataSourceCustomerLoan = null;
    this.dataSourceCustomer = null;
    this.AppCaseNo = null;
    this.CustomerN = null;
    this.Get_ACC_Category_ForDropdown_By_Type();
    $("#CustomerReceipt").modal("show");
    $("#CustomerReceipt").css("z-index", "1050");
  }

  onCloseReceipt() {
    $("#CustomerReceipt").modal("hide");
  }

  onOkReceipt() {
    $("#CustomerReceipt").modal("hide");

  }
  onSearchCustomerDetail() {
    this.showSpinner = true;
    this.Customer.LoginUserId=this.currentUser.userId;
    this._MasterService
      .Get_SearchCustomerByLMSLOS({ JSON: JSON.stringify(this.Customer) })
      .subscribe(
        (res: any) => {
          if (res.length > 0) {
            // Filter using stored loanCategoryIds
            const filtered = res.filter((item: any) =>
              this.loanCategoryIds.includes(item.LoanAccountingId)
            );
  
            if (filtered.length === 1) {
              this.goToDetail(filtered[0]);
            } else if (filtered.length > 1) {
              this.displayedCustomerColumns = [
                "CustomerId",
                "Type",
                "Application_No",
                "LoanAcNo",
                "CustomertName",
                "FatherName",
                "Customer_Gender",
                "GenderAge",
                "PhoneNo",
                "EditAction",
              ];
  
              this.CustomerList = JSON.parse(JSON.stringify(filtered));
              this.CustomerList = this.CustomerList.filter(
                (item) => item.Type == "LMS"
              );
  
              this.dataSourceCustomer = new MatTableDataSource(this.CustomerList);
              this.dataSourceCustomer.sort = this.sort;
              this.dataSourceCustomer.paginator = this.paginatorRef;
            } else {
              // No results after filtering
              this.snackBar.openFromComponent(SnackbarComponent, {
                data: "No matching loan category data found",
                ...this.configSuccess,
              });
              this.dataSourceCustomer = null;
            }
          } else {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: "No data found",
              ...this.configSuccess,
            });
            this.dataSourceCustomer = null;
          }
  
          this.showSpinner = false;
        },
        (error) => {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: "An error occurred while fetching data",
            ...this.configSuccess,
          });
          this.dataSourceCustomer = null;
          this.showSpinner = false;
        }
      );
  }
  
  
  goToDetail(row) {
    this.showSpinner = true;
    this.onCloseReceipt();
    this.lmsService.LMS_Get_LoanPayoutDetail({LoanId: row.LoanId})
    .subscribe((res: any) => {
      this.displayLoanCustomerColumn = [
        "Period",
        "DueDate",
        "EMI_Amount",
        "Interest",
        "Principle",
        "Outstanding_Principle",
        "DSA_EMI_Amount",
        "DSA_Interest",
        "DSA_Principle",
        "DSA_Outstanding_Principle",
        "payout"
      ];
      this.CustomerLoanList = res;
      this.dataSourceCustomerLoan = new MatTableDataSource(this.CustomerLoanList);
      this.dataSourceCustomerLoan.paginator = this.paginatorRef1;
      this.dataSourceCustomerLoan.sort = this.sort;
      console.log("customer loan list",this.CustomerLoanList);
      this.AppCaseNo = row.LoanAcNo;
      this.CustomerN = row.CustomertName;
    });
    this.showSpinner = false;
  }
} 
